import { gql } from '@apollo/client';
import { PREVIEW_CREDIT_FRAGMENT } from 'data/fragments/credit';

export const WALLET_FRAGMENT = gql`
    fragment WalletFragment on Wallet {
        credits {
            ...PreviewCreditFragment
        }
        subventions {
            _id
            name
            description
            categories
            cumulative
            currentAmount
            remainingAmount
            hoursIntervalsAvailable
            imageUrl
            reload
            organization {
                _id
                name
            }
        }
        organizationCard {
            _id
            state
        }
        creditCards {
            _id
            default
            expired
            paymentType
            provider
            retries
            details {
                number
                expiration
                bank
                country
                expYear
                expMonth
            }
        }
        mealVouchers {
            _id
            cardType
            default
            expired
            paymentType
            provider
            details {
                number
                username
                expiration
                bank
                country
            }
        }
    }
    ${PREVIEW_CREDIT_FRAGMENT}
`;
